var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-not-found"},[_c('confirmation-content',{attrs:{"showFooter":false}},[_c('div',{staticClass:"confirmation-content__title confirmation-content__title--warn confirmation-content__title--margin-bottom"},[_vm._v(" Błąd 404 ")]),_c('div',[_vm._v("Szukana strona nie została znaleziona")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }